export const GET_CURRENT_ASSET = "GET_CURRENT_ASSET";
export const REFRESH_CURRENT_ASSET = "REFRESH_CURRENT_ASSET";
export const RESET_CURRENT_ASSET = "RESET_CURRENT_ASSET";
export const SET_CURRENT_ASSET_REQUEST_STATUS = "SET_CURRENT_ASSET_REQUEST_STATUS";
